import { KnownComponentsNames } from '@core/components-names';
import { ChannelNames } from '@itero/itero-client-communication';

export const eventToAppIdMap: { [key: string]: { publisherAppId: string; targetApplications: string[]; channel: ChannelNames } } = {
	'platform-ready': {
		publisherAppId: 'platform',
		targetApplications: ['app-shell'],
		channel: ChannelNames.platformChannel,
	},
	'application-loaded': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['*'],
		channel: ChannelNames.platformChannel,
	},
	'application-closed': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['*'],
		channel: ChannelNames.platformChannel,
	},
	'application-ready': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['*'],
		channel: ChannelNames.platformChannel,
	},
	'application-progress': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['*'],
		channel: ChannelNames.platformChannel,
	},
	'handle-error': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['platform'],
		channel: ChannelNames.platformChannel,
	},
	'prepare-to-close': {
		publisherAppId: 'app-shell',
		targetApplications: [KnownComponentsNames.AohsComponent],
		channel: ChannelNames.platformChannel,
	},
	'closing-rejected': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['app-shell'],
		channel: ChannelNames.platformChannel,
	},
	'close-me': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['app-shell'],
		channel: ChannelNames.platformChannel,
	},
	'push-navigation-state': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['app-shell'],
		channel: ChannelNames.applicationChannel,
	},
	'external-application-failed': {
		publisherAppId: 'platform',
		targetApplications: ['app-shell'],
		channel: ChannelNames.platformChannel,
	},
	'context-bizctx-updated': {
		publisherAppId: 'platform',
		targetApplications: ['*'],
		channel: ChannelNames.platformChannel,
	},
	'context-ui-updated': {
		publisherAppId: 'platform',
		targetApplications: ['*'],
		channel: ChannelNames.platformChannel,
	},
	'token-refreshed': {
		publisherAppId: 'platform',
		targetApplications: ['*'],
		channel: ChannelNames.platformChannel,
	},
	'token-expired': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['platform'],
		channel: ChannelNames.platformChannel,
	},
	'init-context': {
		publisherAppId: 'platform',
		targetApplications: [KnownComponentsNames.AohsComponent],
		channel: ChannelNames.platformChannel,
	},
	'session-updated': {
		publisherAppId: 'platform',
		targetApplications: ['*'],
		channel: ChannelNames.platformChannel,
	},
	'get-iosim-progress': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['platform'],
		channel: ChannelNames.applicationChannel,
	},
	'iosim-progress-results': {
		publisherAppId: 'platform',
		targetApplications: [KnownComponentsNames.AohsComponent],
		channel: ChannelNames.applicationChannel,
	},
	'open-application': {
		publisherAppId: 'app-shell',
		targetApplications: ['app-shell', 'platform'],
		channel: ChannelNames.platformChannel,
	},
	'init-app-metadata': {
		publisherAppId: 'app-shell',
		targetApplications: ['*'],
		channel: ChannelNames.applicationChannel,
	},
	'get-apps-config': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['platform'],
		channel: ChannelNames.platformChannel,
	},
	'apps-config-result': {
		publisherAppId: 'platform',
		targetApplications: [KnownComponentsNames.AohsComponent],
		channel: ChannelNames.platformChannel,
	},
	'screenshot-enabled': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['platform'],
		channel: ChannelNames.applicationChannel,
	},
	'screenshot-clicked': {
		publisherAppId: 'platform',
		targetApplications: ['*'],
		channel: ChannelNames.applicationChannel,
	},
	'screenshot-results': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['platform'],
		channel: ChannelNames.applicationChannel,
	},
	'change-title': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['platform'],
		channel: ChannelNames.applicationChannel,
	},
	'clear-title': {
		publisherAppId: KnownComponentsNames.AohsComponent,
		targetApplications: ['platform'],
		channel: ChannelNames.applicationChannel,
	},
};
